import { render, staticRenderFns } from "./apkIn.vue?vue&type=template&id=5676720c&scoped=true"
import script from "./apkIn.vue?vue&type=script&lang=js"
export * from "./apkIn.vue?vue&type=script&lang=js"
import style0 from "./apkIn.vue?vue&type=style&index=0&id=5676720c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676720c",
  null
  
)

export default component.exports